import {
  SubscriptionContainer,
  SubscriptionHead,
  SubscriptionHeading,
} from "./styles";

const AccessBlockModal = ({ text }) => {
  return (
    <>
      <SubscriptionContainer>
        <SubscriptionHead>
          <SubscriptionHeading>{text}</SubscriptionHeading>
        </SubscriptionHead>
      </SubscriptionContainer>
    </>
  );
};

export default AccessBlockModal;
